<template lang="pug">
	div.settings-control(v-pseudo-modal-name="'settings-control'")

		hr(v-if="setting.separator")
		span(v-else-if="(setting.control === 'input' || setting.control === 'text' || setting.control === 'number' || setting.control === 'color' || setting.control === 'textarea')")
			div.clearfix.mt-4
				span {{setting.title}}
			div
				small.text-muted.pre {{setting.description}}
			.inline-controls(v-pseudo-modal-name="'settings-control-' + setting.codename")
				input.form-control.form-control-sm(v-if="(setting.control !== 'textarea')" :type="(setting.control === 'input' || setting.control === 'text') ? 'text' : setting.control" :value="setting['value']" :placeholder="setting.ControlOptions.placeholder" v-on:input="sendSettingValueToIFrame(setting, $event.target.value)" v-on:change="Settings.setSettingValue(setting, $event.target.value)" :style="setting.ControlOptions['width'] ? {width: setting.ControlOptions['width']} : {}")
				textarea(v-if="(setting.control === 'textarea')" :value="setting['value']" :placeholder="setting.ControlOptions.placeholder" v-on:input="sendSettingValueToIFrame(setting, $event.target.value)" v-on:change="Settings.setSettingValue(setting, $event.target.value)")
				span(v-if="setting.ControlOptions['rangeControl']")
					.range
						input.custom-range(type="range" :min="setting.ControlOptions['rangeControl']['min'] || 0" :max="setting.ControlOptions['rangeControl']['max'] || 1000" :step="setting.ControlOptions['rangeControl'].step || 1" :value="parseFloat(setting['value'])" v-on:input="sendSettingValueToIFrame(setting, $event.target.value, true)" v-on:change="Settings.setSettingValue(setting, $event.target.value)")
				span(v-if="setting.ControlOptions['additionalRightButton']" v-on:click="additionalButtonPress(setting)")
					i.additional-input-button.fa(:class="setting.ControlOptions['additionalRightButton'].icon" v-b-tooltip.hover="{delay: { show: 500, hide: 100 }, title: setting.ControlOptions['additionalRightButton'].hint}")
					//-i.additional-input-button.fa(:class="setting.ControlOptions['additionalRightButton'].icon" v-b-tooltip.hover="{delay: { show: 500, hide: 100 }, title: setting.ControlOptions['additionalRightButton'].hint}")

		span(v-if="setting.control === 'switch'")
			div.clearfix.mt-4
				.switch-setting-wrapper
					span.left-title {{setting.title}}
					label.float-right.switch.switch-label.switch-sm.switch-pill.switch-success.form-check-label
						input.switch-input.form-check-input(type="checkbox" :checked="parseInt(setting['value']) === 1" v-on:change="Settings.setSettingValue(setting, $event.target.checked)")
						span.switch-slider(data-checked="On" data-unchecked="Off")
						span.switch-handle

		span(v-else-if="setting.control === 'list'")
			div.clearfix.mt-4
				span {{setting.title}}
			div
				small.text-muted {{setting.description}}
			ListControl(:setting="setting")

		span(v-else-if="setting.control === 'select'")
			div.clearfix.mt-4
				span {{setting.title}}
				div
					small.text-muted {{setting.description}}
				select.custom-select.custom-select-sm(:name="setting.name" v-on:change="Settings.setSettingValue(setting, $event.target.value)" :style="{'width': '100%'}")
					option(v-for="key in Object.keys(setting.ControlOptions.values)" :selected="setting.value === setting.ControlOptions.values[key]" :value="key") {{setting.ControlOptions.values[key]}}

		span(v-else-if="setting.control === 'radio'")
			div.clearfix.mt-4
				span {{setting.title}}
				div
					small.text-muted {{setting.description}}
				label.form-check.radio(v-for="value in setting.values")
					input.form-check-input(:name="setting.name" :checked="value === setting['value']" type="radio" v-on:change="Settings.setSettingValue(setting, value)")
					span {{(setting['option-descriptions'] && setting['option-descriptions'][value]) ? setting['option-descriptions'][value] : value}}

		span(v-else-if="setting.control === 'range'")
			div.clearfix.mt-4
				span {{setting.title}}
				div
					small.text-muted {{setting.description}}
				div.range
					div
						small.text-muted Value: {{setting['value']  / multiplier + units}}
					input.custom-range(type="range" :min="setting.min" :max="setting.max" :step="setting.step" :value="setting['value']" v-on:input="Settings.setSettingValue(setting, $event.target.value)")
					div.range-values
						div.range-min
							small.text-muted {{setting.min / multiplier + units}}
						div.range-max
							small.text-muted {{setting.max / multiplier + units}}

		span(v-else-if="setting.control === 'checkbox'")
			div.clearfix.mt-4
				span {{setting.title}}
				div
					small.text-muted {{setting.description}}
				.multi-select-checkboxes
					div.multi-select-checkbox.form-check.checkbox(v-for="value in setting.values" :checked="value === setting['value']" :value="value")
						label.form-check-label
							input.form-check-input(type="checkbox" :checked="setting['value'] && setting['value'].includes(value)" v-on:change="Settings.setMultiSelectSettingValue(setting.name, value, $event.target.checked)")
							|{{(setting['option-descriptions'] && setting['option-descriptions'][value]) ? setting['option-descriptions'][value] : value}}

		span(v-else-if="setting.control === 'custom'")
			div.clearfix.mt-4.control-box
				span {{setting.title}}
			div(v-if="setting.description")
				small.text-muted {{setting.description}}
			component(:is="setting.ControlOptions.componentName" :setting="setting")
</template>

<script>

	import Screen 						from './../../mixins/screen';

	import { Template } 				from './../../services/Template'
	import { Settings } 				from './../../services/Settings'

	import ListControl 					from './CustomControls/ListControl'

	import SettingsContentTracking 		from './SettingsContentTracking'
	import SettingsTagMerger			from "./SettingsTagMerger"

	export default {
		name: 'SettingControls',
		mixins: [Screen],
		screen: {
			updateOn: ["Selected Project Changed", "Settings Changed", "Assets Changed"]
		},
		props: ['setting', 'section'],
		components: {
			ListControl,
			SettingsContentTracking,
			SettingsTagMerger
		},
		data() {

			this.Template = Template;
			this.Settings = Settings;

			return {
				showed: true,
				multiplier: this.setting.multiplier || 1,
				units: this.setting.units || ''
			};

		},
		methods: {
			collectData() {

			},
			sendSettingValueToIFrame(setting, value, isUpdateInput = false) {

				value = Settings.fixSettingValue(setting, value);

				let message = {
					settings: {}
				};

				message.settings[setting['codename']] = _.cloneDeep(setting);
				message.settings[setting['codename']]['value'] = value;

				Broadcast.call("Send to IFrame", [message]);

				if (isUpdateInput) {

					setting['value'] = value;

					this.$forceUpdate();

				}

			},
			additionalButtonPress(setting) {

				Broadcast.call("Setting Control Additional Button Pressed", [setting]);

			}
		}
	}
</script>

<style lang="sass">

	.switch-setting-wrapper
		display: flex
		flex-direction: row
		justify-content: space-between
		align-items: center

		.left-title
			width: 75%

	.range
		display: flex
		flex-direction: column

	.range-values
		display: flex
		justify-content: space-between
		user-select: none

	.pre
		white-space: pre-line

	aside.aside-menu
		background-color: #3a4149
		border-left: 1px solid #23282c
		color: #f3f4f5
		cursor: default

		hr
			color: #23282c
			border-top-color: #23282c
			margin-left: -1rem
			margin-right: -1rem
			margin-bottom: -0.5rem

		.switch-slider
			background-color: #343b41
			border: 1px solid #23282c

		.settings-control
			font-size: 0.875rem

			select
				width: auto
				float: left
				margin-top: 5px

			label.form-check.radio
				line-height: 24px
				margin: 0

			.form-check
				cursor: pointer
				font-size: 80%

				input
					cursor: pointer

			textarea
				margin: 3px
				color: #ffffff
				padding: 7px
				width: 100%
				border: 1px solid #23282c
				background-color: #515b65
				border-radius: 5px

			input.form-control.form-control-sm
				margin-top: 2px
				border: 1px solid #23282c
				background-color: #515b65
				background-clip: padding-box
				height: calc(1.5em + 0.5rem + 3px)
				color: #e4e7ea

				&::placeholder
					color: rgba(255, 255, 255, 0.1)

				&[type="color"]
					width: 150px

			.inline-controls
				display: flex
				flex-direction: row
				align-items: center

				.range
					margin-left: 10px
					margin-top: 3px

			.split-input
				display: flex
				white-space: nowrap
				line-height: 30px

				.split-title
					margin-top: 2px
					align-items: center
					padding: .25rem .75rem 0 .75rem
					margin-bottom: 0
					font-size: .875rem
					font-weight: 400
					line-height: 1.5
					color: #e4e7ea
					text-align: center
					white-space: nowrap
					margin-right: -1px
					background-color: #343b41
					background-clip: border-box
					border: 1px solid #23282c
					border-top-left-radius: .25rem
					border-bottom-left-radius: .25rem

				input
					border-top-left-radius: 0
					border-bottom-left-radius: 0

				input.form-control.form-control-sm
					width: 200px

			.additional-input-button
				cursor: pointer
				font-size: 20px
				margin: 7px

		.form-control-w
			width: 200px

</style>
